import { isInternalTech } from './AuthUtils';
import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getRFPFilterConfig = ({ filters, userType, currentUser }) => {
	const isBuyer = userType !== 'supplier' || isInternalTech(currentUser);
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		...(isBuyer ? [filters[FILTER_CONFIG_NAMES.SUPPLIER]] : []),
	].filter(Boolean);
};
